import React from 'react';
import { PageTabsBar } from '@/components/layouts/PageHeader/PageTabsBar';
import { LeaveWithoutSavingDialog } from '@/components/dialogs/LeaveWithoutSavingDialog';
import { useFormFieldConfigScope } from './useFormFieldConfigScope';
import { useGuardedScopeChange } from './useGuardedScopeChange';
import { SCOPE_TABS } from './scopes';

/** The Default, Ledger and Broker group tabs. Switching asks first when there are unsaved changes. */
export const FormFieldConfigScopeTabs = () => {
	const { scope } = useFormFieldConfigScope();
	const { requestScopeChange, leaveDialogProps } = useGuardedScopeChange();

	return (
		<>
			<PageTabsBar
				tabs={SCOPE_TABS}
				value={scope.scope}
				queryParam='tab'
				// The tabs' links only work for new tabs (ctrl / cmd-click); a plain click is
				// handled here
				onChange={(event, nextTab) => requestScopeChange({ scope: nextTab, scopeId: null })}
			/>
			<LeaveWithoutSavingDialog {...leaveDialogProps} />
		</>
	);
};

FormFieldConfigScopeTabs.displayName = 'FormFieldConfigScopeTabs';
